import { render, staticRenderFns } from "./MemberTypeService.vue?vue&type=template&id=bd9727c0&"
import script from "./MemberTypeService.vue?vue&type=script&lang=js&"
export * from "./MemberTypeService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports